// extracted by mini-css-extract-plugin
export default {"placeholder":"login-streak_placeholder__X2ume","active":"login-streak_active__+7mom","day":"login-streak_day__P89Yj","days":"login-streak_days__tZv6r"};